import React, { useEffect, useReducer, useState } from "react";
import { Blog } from "../../types/type";
import BlogCard from "../helpers/blog/BlogCard";
import { Link } from "react-router-dom";
import { getBlogs } from "../../utils/apis/func";
import { addBlog, addisLoading } from "../../utils/redux/mainSlice";
import { RootState } from "../../utils/redux/store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../utils/redux/hooks";
import Scrollbar from "../scrollbar";

function BlogContent() {
  const dispatch = useDispatch();
  const blogs = useAppSelector((store: RootState) => store.user.blogs);
  const itemsPerPage = 10;
  const totalItems = blogs?.length;

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = blogs?.slice(startIndex, endIndex);

  const filteredBlogs =
    searchTerm.length > 0
      ? itemsToShow.filter((item: any) =>
          item?.businessName?.toLowerCase()?.includes(searchTerm.toLowerCase())
        )
      : itemsToShow;

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    (async () => {
      dispatch(addisLoading(true));
      const res: any = await getBlogs("");
      if (res?.status === 200 || res?.status === 201) {
        const blogs: Blog[] = res?.data?.data;
        dispatch(addBlog(blogs));
      }

      dispatch(addisLoading(false));
    })();
  }, []);
  return (
    <div>
      <header className="flex-1 flex justify-end py-2">
        <Link to="/create-blog">
          <div
            role="button"
            className="bg-[#88087B] text-white rounded-lg px-4 py-2"
          >
            Create new Blog
          </div>
        </Link>
      </header>
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredBlogs.map((blog) => (
            <BlogCard blog={blog} key={blog._id} />
          ))}
        </div>
      </div>
      {filteredBlogs.length === 0 && (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500 text-lg">No blogs available</p>
        </div>
      )}

      <Scrollbar
        currentPage={currentPage}
        totalPages={Math.ceil(totalItems / itemsPerPage)}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPrevPageClick={handlePrevPageClick}
        onNextPageClick={handleNextPageClick}
      />
    </div>
  );
}

export default BlogContent;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
